import API from './API';

const PaymentAPI = {
	register: data => API.post('/payments/register', data),
	check: () => API.get('/payments/check'),
};

export default PaymentAPI;
